import * as Sentry from '@sentry/react';

export const debugLog = (...args: unknown[]): void => {
   if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.log(...args);
   }
};

export const debugError = (...args: unknown[]): void => {
   if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.error(...args);
   }
   
   // if (process.env.NODE_ENV !== 'development') {
   const first = args[0];
   if (first instanceof Error) {
      Sentry.captureException(first);
   } else if (args.length > 0) {
      Sentry.captureMessage(String(first), 'error');
   }
   // }
};

export const debugWarn = (...args: unknown[]): void => {
   if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn(...args);
   }
};
